import { StandByModes } from './enums/stand-by-modes';

export class SetInStandByStateData {
    public constructor(
        public mode: StandByModes,
        public duration: number = null,
        public endDate: Date = null
    ) {}
}
